import jsonpath from 'jsonpath';
import factory from 'rfdc';

export const encode = (data: any, replacer?: (key: string, value: any) => any, space?: string | number) => JSON.stringify(data, replacer, space);
export const decode = (data: string, reviver?: (key: string, value: any) => any) => JSON.parse(data, reviver);

export const path = (path: (string | number)[]) => jsonpath.stringify(path);

export const nodes = (data: any, path: string) => jsonpath.nodes(data, path).map(({ path, value }) => ({ path: jsonpath.stringify(path), value }));
export const paths = (data: any, path: string) => jsonpath.paths(data, path).map(path => jsonpath.stringify(path));
export const query = (data: any, path: string) => jsonpath.query(data, path);

export const value = (data: any, path: string) => jsonpath.value(data, path);
export const assign = (data: any, path: string, value: any) => jsonpath.value(data, path, value);
export const remove = (data: any, target: string) => nodes(data, '$..*').reduce((current, { path, value }) => {
  if (path !== target) jsonpath.value(current, path, value); return current;
}, {});

export const parent = (data: any, path: string) => {
  try { return jsonpath.parent(data, path); } catch { }
};

export const pick = (data: any, paths: string[]) => {
  return paths.reduce((current, path) => {
    const key = `$.${path}`;
    assign(current, key, value(data, key));

    return current;
  }, {});
};

export const build = (nodes: { path: string, value: any }[], data?: any) => nodes.reduce((current, { path, value }) => {
  jsonpath.value(current, path, value); return current;
}, (data ?? {}));
export const expand = (data: any) => build(Object.entries(data).map(([path, value]) => ({ path, value })));

export const equals = (data: any, other: any) => {
  const sorter = (a: any, b: any) => a.path.localeCompare(b.path);

  const first = build(nodes(data, '$..*').sort(sorter));
  const second = build(nodes(other, '$..*').sort(sorter));

  return (encode(first) === encode(second));
};

export const clone = factory({ circles: true });

export const process = (data: any, opts: Record<string, string | boolean | ((o: any, p: string, a: any) => [p: string, o: any])>): any => {
  if (!data) return;

  return nodes(data, '$..*').reduce<any>((current, { path, value }) => {
    const option = (opts[path] ?? opts['$..*'] ?? true);
    if (option) switch (typeof option) {
      case 'function': jsonpath.value(current, ...option(value, path, data)); break;
      case 'string': assign(current, option, value); break;
      default: assign(current, path, value); break;
    }

    return current;
  }, {});
};
